import React from 'react';

import './WitcMediumAnswerHintStrip.css';

export interface WitcMediumAnswerHintStripProps {
  /** Only `_`, spaces, punctuation — no real letters except from API hints. */
  skeleton: string;
  /** Index → one character revealed by server on 2nd wrong guess. */
  revealedByIndex: ReadonlyMap<number, string> | Record<number, string>;
}

function getRevealed(
  i: number,
  revealedByIndex: ReadonlyMap<number, string> | Record<number, string>
): string | undefined {
  if (revealedByIndex instanceof Map) return revealedByIndex.get(i);
  return Object.prototype.hasOwnProperty.call(revealedByIndex, i)
    ? (revealedByIndex as Record<number, string>)[i]
    : undefined;
}

/**
 * White strip: skeleton shows slot count; server-sent hints fill individual indices only.
 */
const WitcMediumAnswerHintStrip: React.FC<WitcMediumAnswerHintStripProps> = ({
  skeleton,
  revealedByIndex,
}) => {
  const chars = Array.from(skeleton);

  return (
    <div
      className="witc-medium-hint-strip border rounded bg-white px-3 py-3 mb-3 shadow-sm"
      aria-live="polite"
    >
      <div className="witc-medium-hint-strip__inner d-flex flex-wrap align-items-end gap-y-2">
        {chars.map((ch, i) => {
          const revealed = getRevealed(i, revealedByIndex);
          if (revealed !== undefined && revealed !== '') {
            return (
              <span key={i} className="witc-medium-hint-char witc-medium-hint-char--revealed flex-shrink-0">
                {revealed}
              </span>
            );
          }
          if (ch === ' ') {
            return (
              <span key={i} className="witc-medium-hint-space flex-shrink-0" aria-hidden>
                &nbsp;&nbsp;
              </span>
            );
          }
          if (ch === '_') {
            return (
              <span key={i} className="witc-medium-hint-char flex-shrink-0">
                _
              </span>
            );
          }
          return (
            <span key={i} className="witc-medium-hint-punct flex-shrink-0">
              {ch}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default WitcMediumAnswerHintStrip;
